<script>
  export let data;
  export let columns;

  const maxField = columns.filter(c => c.value)[0].key;
  const max = Math.max(...data.map(d => d[maxField]));
</script>

<svelte:head>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/charts.css/dist/charts.min.css">
</svelte:head>

<table class={ $$props.class } class:charts-css={ true } >
  <thead>
    <tr>
      {#each columns as column}
        <th scope="col">{ column.label }</th>
      {/each}
    </tr>
  </thead>
  <tbody>
    {#each data as item}
      <tr>
        {#each columns as column, i}
          {#if i}
            <td style="--size: { item[column.key] / max }">{ item[column.key] }</td>
          {:else}
            <th scope="row">{ item[column.key] }</th>
          {/if}
        {/each}
      </tr>
    {/each}
  </tbody>
</table>